import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { OG_IMAGE, SITE_URL } from '../../lib/seo'

export default function SEO({
  title = 'Mathos Consult — Service Design Practice | Alexander Miller',
  description = 'Mathos Consult is a service design practice led by Alexander Miller. We help founders and leadership teams design products, services and operations that work for the people who use them.',
  image = OG_IMAGE,
  type = 'website',
  jsonLd = null,
}) {
  const location = useLocation()
  const url = `${SITE_URL}${location.pathname}`
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null

  useEffect(() => {
    // Update document title
    document.title = title

    // Update meta tags
    updateMetaTag('description', description)
    updateMetaTag('og:title', title, 'property')
    updateMetaTag('og:description', description, 'property')
    updateMetaTag('og:image', image, 'property')
    updateMetaTag('og:url', url, 'property')
    updateMetaTag('og:type', type, 'property')
    updateMetaTag('twitter:card', 'summary_large_image')
    updateMetaTag('twitter:title', title)
    updateMetaTag('twitter:description', description)
    updateMetaTag('twitter:image', image)

    // Update canonical link
    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', url)

    // Update or remove JSON-LD <script>
    const scriptId = 'seo-jsonld'
    let scriptEl = document.head.querySelector(`script#${scriptId}`)
    if (jsonLdString) {
      if (!scriptEl) {
        scriptEl = document.createElement('script')
        scriptEl.id = scriptId
        scriptEl.type = 'application/ld+json'
        document.head.appendChild(scriptEl)
      }
      scriptEl.textContent = jsonLdString
    } else if (scriptEl) {
      scriptEl.remove()
    }
  }, [title, description, image, url, type, jsonLdString])

  return null
}

function updateMetaTag(name, content, attribute = 'name') {
  let element = document.querySelector(`meta[${attribute}="${name}"]`)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}
